module.exports = __webpack_public_path__ + "img/Rectangle 61.b2c2523e.png";